import { Form } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import "./FilterSectionPayment.css";

const FilterSection = ({ selectedSituation = [], handleSituationFilter }) => {
  const ALL_SITUATIONS = [
    "Conferência pendente",
    "Comprovantes pendentes",
    "Conferência em andamento",
    "Correção pendente",
    "Assinatura pendente",
    "Assinatura expirada",
    "Assinatura Concluída",
  ];

  const isAllSelected =
    ALL_SITUATIONS.length > 0 &&
    ALL_SITUATIONS.every((s) => selectedSituation.includes(s));

  const toggleOne = (label) => {
    handleSituationFilter(label);
  };

  const toggleAll = () => {
    if (isAllSelected) {
      handleSituationFilter([]);
      return;
    }
    handleSituationFilter([...ALL_SITUATIONS]);
  };

  return (
    <div className="filters-section">
      <div className="filter-label">
        <FaFilter style={{ marginRight: "5px" }} /> Situação:
      </div>

      <div className="checkbox-grid">
        <div className="checkbox-line checkbox-line-all">
          <Form.Check
            inline
            label="Todos"
            type="checkbox"
            checked={isAllSelected}
            onChange={toggleAll}
          />
        </div>

        <div className="checkbox-line">
          <Form.Check
            inline
            label="Conferência Pendente"
            type="checkbox"
            checked={selectedSituation.includes("Conferência pendente")}
            onChange={() => toggleOne("Conferência pendente")}
          />
          <Form.Check
            inline
            label="Comprovantes Pendentes"
            type="checkbox"
            checked={selectedSituation.includes("Comprovantes pendentes")}
            onChange={() => toggleOne("Comprovantes pendentes")}
          />
          <Form.Check
            inline
            label="Conferência em andamento"
            type="checkbox"
            checked={selectedSituation.includes("Conferência em andamento")}
            onChange={() => toggleOne("Conferência em andamento")}
          />
        </div>

        <div className="checkbox-line">
          <Form.Check
            inline
            label="Correção Pendente"
            type="checkbox"
            checked={selectedSituation.includes("Correção pendente")}
            onChange={() => toggleOne("Correção pendente")}
          />
          <Form.Check
            inline
            label="Assinatura Pendente"
            type="checkbox"
            checked={selectedSituation.includes("Assinatura pendente")}
            onChange={() => toggleOne("Assinatura pendente")}
          />
          <Form.Check
            inline
            label="Assinatura Expirada"
            type="checkbox"
            checked={selectedSituation.includes("Assinatura expirada")}
            onChange={() => toggleOne("Assinatura expirada")}
          />
        </div>

        <div className="checkbox-line">
          <Form.Check
            inline
            label="Assinatura Concluída"
            type="checkbox"
            checked={selectedSituation.includes("Assinatura Concluída")}
            onChange={() => toggleOne("Assinatura Concluída")}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterSection;
